import { EXPERIMENT_FREE_ACCOUNT } from '@constant/experiments';
import LaunchDarkly from '@module/launchdarkly';

const FREE_EXPIRY = '1w';
const FREE_EXPIRY_ON_CHANNEL = '1m';

// The maximum byte size for our message
const MAX_MESSAGE_SIZE_IN_BYTES = 65535;

// From Devise: /\A[^@\s]+@([^@\s]+\.)+[^@\s]+\z/
const REGEXP_EMAIL_LABEL = /^((.+\s)<([^@\s]+@([^@\s]+\.)+[^@\s]+)>|(<|\(|')?([^@\s]+@([^@\s]+\.)+[^@\s>)']+)('|\)|>)?)$/im;
const REGEXP_EMAIL = /^([^@\s]+@([^@\s]+\.)+[^@\s]+)$/im;
const REGEXP_BLANK = /\s*/g;

export {
  FREE_EXPIRY,
  FREE_EXPIRY_ON_CHANNEL,
  MAX_MESSAGE_SIZE_IN_BYTES,
  REGEXP_EMAIL_LABEL,
  REGEXP_EMAIL,
  REGEXP_BLANK,
};

const freeUserFileSizeLimitGB = LaunchDarkly.getVariant(EXPERIMENT_FREE_ACCOUNT)
  ? 1
  : 2;

export default {
  // Define limits for free/plus/etc.
  limits: {
    free: {
      recipient: 3,
      files: 4000,
      bytes: 1024 * 1024 * 1024 * freeUserFileSizeLimitGB,
    },
    freeAccount: {
      recipient: 10,
      files: 4000,
      bytes: 1024 * 1024 * 1024 * 2,
    },
    plus: {
      recipient: 50,
      files: 4000,
      bytes: 1024 * 1024 * 1024 * 20,
    },
  },

  // Settings for API requests
  api: {
    endpoint: '/api/v4',
    // Timeout regular requests in 30s
    timeout: 30 * 1000,
    // Timeout retriable requests in 60 minutes.
    // This is the total time for all retries.
    retriableTimeout: 60 * 60 * 1000,
    retry: {
      limit: 100,
    },
  },

  // Settings for chunked uploads
  upload: {
    chunk: {
      minSize: 1024 * 1024 * 5,
      maxCount: 999,
    },

    retry: {
      limit: 100,
      interval: 2000,
      autopause: true, // on failure, pause instead of abort
    },
  },

  // Settings for the queue
  queue: {
    parallel: {
      minSpeed: 1024 * 1024 * 0.5, // mb/s per chunk
      min: 1,
      max: 3,
    },
  },

  // Settings for the progress indicator
  progress: {
    interval: 500,
  },
};
